import { protectedClient } from '@/lib/api.ts';

const currentAuthUserQueryFn = async () => {
  const { data } = await protectedClient.get('/recruitment/current-auth-user');
  return data;
};

export default currentAuthUserQueryFn;
